<template>
  <div>
    <transition mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  export default {

  }
</script>



// WEBPACK FOOTER //
// src/App.vue